import { useContextAppointment } from "@/modules/patients/hooks/useContextAppointment"
import { DocumentLanguage } from "@/modules/patients/libs/document-languages"
import { Language } from "@/types/__generated__/union-types"

const DOCUMENT_LANGUAGES: Array<{ value: DocumentLanguage; label: string }> = [
  { value: "GERMAN", label: "common.languageList.german" },
  { value: "FRENCH", label: "common.languageList.french" },
  { value: "ITALIAN", label: "common.languageList.italian" },
]

const DOCUMENT_LANGUAGES_INCLUDE_ENGLISH: Array<{ value: Language; label: string }> = [
  { value: "ENGLISH", label: "common.languageList.english" },
  ...DOCUMENT_LANGUAGES,
]

const getDocumentLanguageLabel = (value: string, includeEnglish?: boolean) => {
  const documentLanguages = includeEnglish ? DOCUMENT_LANGUAGES_INCLUDE_ENGLISH : DOCUMENT_LANGUAGES
  return documentLanguages.find((option) => option.value === value)?.label ?? ""
}

const useDefaultDocumentLanguage = () => {
  const contextAppointment = useContextAppointment()
  const appointmentLanguage = contextAppointment?.language

  const documentLanguage: DocumentLanguage =
    DOCUMENT_LANGUAGES.find((lang) => lang.value === appointmentLanguage)?.value ?? "GERMAN"

  const documentLanguageIncludeEnglish: Language =
    DOCUMENT_LANGUAGES_INCLUDE_ENGLISH.find((lang) => lang.value === appointmentLanguage)?.value ?? "GERMAN"

  return { documentLanguage, documentLanguageIncludeEnglish }
}

export { useDefaultDocumentLanguage, DOCUMENT_LANGUAGES, getDocumentLanguageLabel, DOCUMENT_LANGUAGES_INCLUDE_ENGLISH }
